import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import UserAvatar from 'react-user-avatar';
import PostForm from "./PostForm";
import BodyParser from "./BodyParser";
import * as apiConfig from "../../api/config";
import moment from "moment"
import $ from 'jquery';

function CommentControl({
    user,
    mode,
    active,
    headless,
    comment,
    cssClass,
    onReplyToComment,
    onEditComment,
    onEditCommentReply,
    onDeleteComment,
    onDeleteCommentReply,
    onDeleteCommentImage
}) {

    const [commentToDelete, setCommentToDelete] = useState({});
    const [commentToEdit, setCommentToEdit] = useState({ body: "" });
    const [lightboxImage, setLightboxImage] = useState("");

    $(`.comment-details-${comment.id}`).hover(showOptions, hideOptions)

    useEffect(() => {

    }, [comment]);

    function showOptions() {
        $(`.comment-options-${comment.id}`).show()
    }

    function hideOptions() {
        $(`.comment-options-${comment.id}`).hide()
    }

    function onOpenEditComment(comment) {
        setCommentToEdit(comment)
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).show();
        }
        $(`#editComment-${comment.id}`).modal("show");
    }

    function onCloseEditCommentModal(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#editComment-${comment.id}`).modal("hide");
    }

    function onOpenEditCommentReply(comment) {
        setCommentToEdit(comment)
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).show();
        }
        $(`#editCommentReply-${comment.id}`).modal("show");
    }

    function onCloseEditCommentReplyModal(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#editCommentReply-${comment.id}`).modal("hide");
    }

    function onCommentEditChange(e) {
        var { name, value } = e.target;
        setCommentToEdit(prevCommentToEdit => ({
            ...prevCommentToEdit,
            [name]: value
        }));
    }

    function handleImagesChange(images) {
        setCommentToEdit(prevCommentToEdit => ({
            ...prevCommentToEdit,
            images: images
        }));
    }

    function onCommentEditSave(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#editComment-${comment.id}`).modal("hide");
        onEditComment(commentToEdit)
    }

    function onCommentReplyEditSave(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#editCommentReply-${comment.id}`).modal("hide");
        onEditCommentReply(commentToEdit)
    }

    function onConfirmDeleteComment(comment) {
        setCommentToDelete(comment);
        //console.log("delete comment? : " + comment.id);

        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).show();
        }
        $(`#confirmDeleteComment-${comment.id}`).modal("show");
    }

    function onCloseConfirmDeleteCommentModal(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#confirmDeleteComment-${comment.id}`).modal("hide");
    }

    function onConfirmDeleteReply(comment) {
        setCommentToDelete(comment);
        //console.log("delete reply? : " + comment.id);

        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).show();
        }
        $(`#confirmDeleteReply-${comment.id}`).modal("show");
    }

    function onCloseConfirmDeleteReplyModal(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#confirmDeleteReply-${comment.id}`).modal("hide");
    }

    function handleDeleteComment() {
        //console.log("destroying comment!! : " + commentToDelete.id);

        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#confirmDeleteComment-${comment.id}`).modal("hide");
        onDeleteComment(commentToDelete)
    }

    function handleDeleteReply() {
        //console.log("destroying reply!! : " + commentToDelete.id);

        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#confirmDeleteReply-${comment.id}`).modal("hide");
        onDeleteCommentReply(commentToDelete)
    }

    function openLightbox(imageName) {
        setLightboxImage(imageName);
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).show();
        }
        $(`#comment-lightbox-${comment.id}`).modal("show");
    }

    function onCloseLightboxModal(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#comment-lightbox-${comment.id}`).modal("hide");
    }

    function onConfirmDeleteImage(e) {
        e.preventDefault();
        $(`#comment-lightbox-${comment.id}`).modal("hide");
        $(`#confirmDeleteCommentImage-${comment.id}`).modal("show");
    }

    function onCancelDeleteImage(e) {
        e.preventDefault();
        $(`#comment-lightbox-${comment.id}`).modal("show");
        $(`#confirmDeleteCommentImage-${comment.id}`).modal("hide");
    }

    function handleDeleteImage() {
        if (headless) {
            $(`#comment-feed-mask-${comment.postId}`).hide();
        }
        $(`#confirmDeleteCommentImage-${comment.id}`).modal("hide");
        onDeleteCommentImage(comment.id, lightboxImage);
    }


    return (
        <React.Fragment>
            {mode == "comment" ?
                    <React.Fragment>
                        <div className={`comment ${cssClass}`} >
                            <div className="comment-avatar">
                                <Link to={`/user/profile/${comment.authorId}`}>
                                {(user.id && user.id.toUpperCase() == comment.authorId.toUpperCase()) ?
                                    <UserAvatar size="40" className="comment-avatar-img" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                    :
                                    <UserAvatar size="40" className="comment-avatar-img" name={`${comment.authorFirstName} ${comment.authorSurname}`} src={comment.authorHasAvatar ? `${apiConfig.API_URL}user/avatar/${comment.authorId}.png` : ""} />
                                }
                            </Link>
                            </div>
                        <div className={`comment-details comment-details-${comment.id}`}>
                                <div className="comment-details-inner">
                                    <div className="comment-body">
                                        {comment.images.map(image => {
                                            return (
                                                <img key={image.fileName} src={`${apiConfig.API_URL}postcomment/commentimage/${comment.id}/${image.fileName}`} className="d-block w-100" alt="..." onClick={() => { openLightbox(image.fileName) }} />
                                            )
                                        })}
                                        <BodyParser postId={comment.id} body={comment.body} />
                                    </div>
                                    <div className="comment-footer">
                                        <small className="text-muted"><Link to={`/user/profile/${comment.authorId}`}>{`${comment.authorFirstName} ${comment.authorSurname}`}</Link>{`${cssClass == "set-last" ? " last" : ""} commented ${moment(comment.postedOn).fromNow()}`}</small>
                                    {active &&
                                        <button className="btn btn-link btn-sm comment-reply-btn" onClick={() => onReplyToComment({ postId: comment.postId, id: comment.id })}>
                                            <small className="comment-reply-btn" >Reply</small>
                                        </button>
                                    }
                                    </div>
                                </div>
                            {(user.id.toUpperCase() == comment.authorId.toUpperCase() && active ) &&
                                <div className={`comment-options comment-options-${comment.id}`} style={{ display: "none"}} title="Delete" >
                                    <span className="comment-options-edit fas fa-edit" onClick={() => onOpenEditComment(comment)}></span>
                                    <span className="comment-options-delete fas fa-times" onClick={() => onConfirmDeleteComment(comment)}></span>
                                </div>}
                            </div>
                        </div>
                    <div className="modal fade" id={`confirmDeleteComment-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"} role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title" >Delete Comment?</h5>
                                    <button type="button" className="close" onClick={onCloseConfirmDeleteCommentModal} aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        Are you sure that you want to delete this comment?
                                </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-link" data-dismiss="modal">No</button>
                                        <button type="button" className="btn btn-info" onClick={handleDeleteComment}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <div className="comment-reply-modal modal fade" id={`editComment-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"} role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title" >Edit Comment</h5>
                                    <button type="button" className="close" onClick={onCloseEditCommentModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <PostForm post={commentToEdit} user={user} placeholder="Enter comment..." saveButtonText="Save" alwaysShowSubmit={true} onSave={onCommentEditSave} onChange={onCommentEditChange} onImagesChange={handleImagesChange} />
                                </div>
                            </div>
                    </div>
                    <div className="modal fade" id={`confirmDeleteCommentImage-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title" >Delete Image?</h5>
                                    <button type="button" className="close" onClick={onCancelDeleteImage} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    Are you sure that you want to delete this image?
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-link" onClick={onCancelDeleteImage}>No</button>
                                    <button type="button" className="btn btn-info" onClick={handleDeleteImage}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lightbox-modal modal fade" id={`comment-lightbox-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-xl  modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    {(user.id && user.id.toUpperCase() == comment.authorId.toUpperCase()) ?
                                        <UserAvatar size="35" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                        :
                                        <UserAvatar size="35" name={`${comment.authorFirstName} ${comment.authorSurname}`} src={comment.authorHasAvatar ? `${apiConfig.API_URL}user/avatar/${comment.authorId}.png` : ""} />
                                    } 
                                    <div className="ml-2 mt-1">
                                        <span className="muted">Posted by <Link onClick={() => { $(`#post-lightbox-${comment.id}`).modal("hide"); }} to={`/user/profile/${comment.authorId}`}>{`${comment.authorFirstName} ${comment.authorSurname}`}</Link> {moment(comment.postedOn).fromNow()}</span>
                                    </div>
                                    {user.id.toUpperCase() == comment.authorId.toUpperCase() &&
                                        <div className="carousel-options">
                                            <div className="dropdown dropright">
                                                <button className="btn btn-link carousel-options-btn" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span className="fas fa-ellipsis-h"></span>
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="dLabel">
                                                    <a className="dropdown-item" onClick={onConfirmDeleteImage} href="#">Delete</a>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <button type="button" className="close" onClick={onCloseLightboxModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="post-images">
                                        <div className="carousel">
                                            <div className="carousel-inner">
                                                <div className="post-carousel-lightbox-image-container ">
                                                    <img src={`${apiConfig.API_URL}postcomment/commentimage/${comment.id}/${lightboxImage}`} className="post-carousel-lightbox-image" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </React.Fragment>  
            
                :
                    <React.Fragment>    
                        <div className={`comment-reply ${cssClass}`}>
                            <div className="comment-avatar">
                                <Link to={`/user/profile/${comment.authorId}`}>
                                    {(user.id && user.id.toUpperCase() == comment.authorId.toUpperCase()) ?
                                        <UserAvatar size="40" className="comment-avatar-img" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                        :
                                        <UserAvatar size="40" className="comment-avatar-img" name={`${comment.authorFirstName} ${comment.authorSurname}`} src={comment.authorHasAvatar ? `${apiConfig.API_URL}user/avatar/${comment.authorId}.png` : ""} />
                                    } 
                                </Link>
                            </div>
                            <div className={`comment-details comment-details-${comment.id}`}>
                                <div className="comment-details-inner">
                                    <div className="comment-body">
                                        {comment.images.map(image => {
                                            return (
                                                <img key={image.fileName} src={`${apiConfig.API_URL}postcomment/commentimage/${comment.id}/${image.fileName}`} className="d-block w-100" alt="..." onClick={() => { openLightbox(image.fileName) }}/>
                                                )
                                        })}
                                        <BodyParser postId={comment.id} body={comment.body} />
                                    </div>
                                    <div className="comment-footer">
                                        <small className="text-muted"><Link to={`/user/profile/${comment.authorId}`}>{`${comment.authorFirstName} ${comment.authorSurname}`}</Link>{`${cssClass == "set-last" ? " last" : ""} replied ${moment(comment.postedOn).fromNow()}`}</small>
                                    {active &&
                                        <button className="btn btn-link btn-sm comment-reply-btn" onClick={() => onReplyToComment({ postId: comment.postId, id: comment.parentId })}>
                                            <small className="comment-reply-btn" >Reply</small>
                                        </button>
                                    }
                                    </div>
                                </div>
                            {(user.id.toUpperCase() == comment.authorId.toUpperCase() && active ) && 
                                <div className={`comment-options comment-options-${comment.id}`} title="Delete" style={{ display: "none" }} >
                                    <span className="comment-options-delete fas fa-times" onClick={() => onConfirmDeleteReply(comment)}></span>
                                    <span className="comment-options-edit fas fa-edit" onClick={() => onOpenEditCommentReply(comment)}></span>
                                </div>
                            }
                            </div>
                        </div>
                            
                    <div className="modal fade" id={`confirmDeleteReply-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"}  role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                        <h5 className="modal-title" >Delete Reply?</h5>
                                        <button type="button" className="close" onClick={onCloseConfirmDeleteReplyModal} aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        Are you sure that you want to delete this reply?
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-link" data-dismiss="modal">No</button>
                                        <button type="button" className="btn btn-info" onClick={handleDeleteReply}>Yes</button>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div className="comment-reply-modal modal fade" id={`editCommentReply-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title" >Edit Reply</h5>
                                    <button type="button" className="close" onClick={onCloseEditCommentReplyModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <PostForm post={commentToEdit} user={user} placeholder="Enter reply..." saveButtonText="Save" alwaysShowSubmit={true} onSave={onCommentReplyEditSave} onChange={onCommentEditChange} onImagesChange={handleImagesChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id={`confirmDeleteCommentImage-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title" >Delete Image?</h5>
                                    <button type="button" className="close" onClick={onCancelDeleteImage} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    Are you sure that you want to delete this image?
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-link" onClick={onCancelDeleteImage}>No</button>
                                    <button type="button" className="btn btn-info" onClick={handleDeleteImage}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lightbox-modal modal fade" id={`comment-lightbox-${comment.id}`} tabIndex="-1" data-backdrop={headless && "static"} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-xl  modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    {(user.id && user.id.toUpperCase() == comment.authorId.toUpperCase()) ?
                                        <UserAvatar size="35" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                        :
                                        <UserAvatar size="35" name={`${comment.authorFirstName} ${comment.authorSurname}`} src={comment.authorHasAvatar ? `${apiConfig.API_URL}user/avatar/${comment.authorId}.png` : ""} />
                                    } 
                                    <div className="ml-2 mt-1">
                                        <span className="muted">Posted by <Link onClick={() => { $(`#post-lightbox-${comment.id}`).modal("hide"); }} to={`/user/profile/${comment.authorId}`}>{`${comment.authorFirstName} ${comment.authorSurname}`}</Link> {moment(comment.postedOn).fromNow()}</span>
                                    </div>
                                    {user.id.toUpperCase() == comment.authorId.toUpperCase() &&
                                        <div className="carousel-options">
                                            <div className="dropdown dropright">
                                                <button className="btn btn-link carousel-options-btn" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span className="fas fa-ellipsis-h"></span>
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="dLabel">
                                                    <a className="dropdown-item" onClick={onConfirmDeleteImage} href="#">Delete</a>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <button type="button" className="close" onClick={onCloseLightboxModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="post-images">
                                        <div className="carousel">
                                            <div className="carousel-inner">
                                                <div className="post-carousel-lightbox-image-container ">
                                                    <img src={`${apiConfig.API_URL}postcomment/commentimage/${comment.id}/${lightboxImage}`} className="post-carousel-lightbox-image" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>  
            }
        </React.Fragment>  
    );

}

CommentControl.propTypes =
{
    user: PropTypes.object,
    mode: PropTypes.string.isRequired,
    active: PropTypes.bool,
    headless: PropTypes.bool,
    comment: PropTypes.object.isRequired,
    cssClass: PropTypes.string,
    onReplyToComment: PropTypes.func.isRequired,
    onEditComment: PropTypes.func,
    onDeleteComment: PropTypes.func,
    onDeleteCommentReply: PropTypes.func,
    onDeleteCommentImage: PropTypes.func,
    errorMessage: PropTypes.string
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentControl); 



// WEBPACK FOOTER //
// ./src/components/postComments/CommentControl.js